import { isNotNilOrEmpty } from 'shared/utils/ramda'

import {
  ProductBadgeProps,
  ProductBadgeSizes,
  TagsTypes} from '../types/products'

export const isBioBadgeName = (name: string): boolean => {
  return name.trim().toLowerCase() === 'bio'
}

export const badgesSegregation = (
  tags: TagsTypes[],
  size: ProductBadgeSizes
): ProductBadgeProps[] => {
  const bioBadges: ProductBadgeProps[] = []
  const otherBadges: ProductBadgeProps[] = []

  if (isNotNilOrEmpty(tags)) {
    // if tags are available
    tags.forEach((tag: TagsTypes) => {
      // if tags should be displayed
      if (tag.tag.isVisible) {
        const isBio = isBioBadgeName(tag.tag?.name || '')

        // if the tag is a badge
        if (tag.tag.type === 'product') {
          const badge: ProductBadgeProps = {
            name: tag.tag?.name || '',
            imagePath: tag.tag.icon?.path || '',
            color: tag.tag?.iconColor || '',
            size: size,
            id: tag.tag?.id || '',
            isBio
          }

          if (isBio) {
            bioBadges.push(badge)
          } else {
            otherBadges.push(badge)
          }
        }
      }
    })
  }

  return [...bioBadges, ...otherBadges]
}

export const tagsSegregation = (tags: TagsTypes[]): string[] => {
  let tempParsedTags: string[] = []

  if (isNotNilOrEmpty(tags)) {
    // if tags are available
    tags.map((tag: TagsTypes) => {
      // if tags should be displayed
      if (tag.tag?.isVisible || tag?.isVisible) {
        // if the tag is a badge
        if (tag.tag?.type === 'commercial' || tag.type === 'commercial') {
          tempParsedTags = [...tempParsedTags, tag.tag?.name || tag?.name]
        }
      }
    })
  }

  const result: string[] = []

  tempParsedTags.forEach((tag: string) => {
    if (!result.includes(tag)) {
      result.push(tag)
    }
  })

  return result
}
